import { Route, Routes, useNavigate } from "react-router-dom";
import TelaPermissao from "../../../../Base/Permissao/TelaPermissao";
import MovimentacaoConsultaScreen from "./MovimentacaoConsultaScreen";
import MovimentacaoFormScreen from "./MovimentacaoFormScreen";
import { Movimentacao } from "../../../../../Models/Financeiro/Conta/Movimentacao";
import MovimentacaoEditarScreen from "./MovimentacaoEditarScreen";
import MovimentacaoVisualizar from "./MovimentacaoVisualizar";
interface IMovimentacaoScreenProps {

}
export default function MovimentacaoScreen({
    
}:IMovimentacaoScreenProps) {
    const navigate = useNavigate();

    return <Routes>
        <Route path="/" index element={<TelaPermissao permissoes={["FinanceiroContaMovimentacaoListarTodos"]}><MovimentacaoConsultaScreen /></TelaPermissao>}></Route>
        <Route path="/Novo" element={
            <TelaPermissao permissoes={["FinanceiroContaMovimentacaoInserir"]}>
                <MovimentacaoFormScreen 
                    initialValues={{
                        dataMovimentacao : new Date()
                    } as Movimentacao}
                    onCancelar={() => navigate(-1)}
                />
            </TelaPermissao>
        }/>
        <Route path="/Editar/:codigo" element={
            <TelaPermissao permissoes={["FinanceiroContaMovimentacaoAlterar"]}>
                <MovimentacaoEditarScreen
                    onCancelar={() => navigate(-1)}
                />
            </TelaPermissao>
        }/>
        <Route path="/Visualizar/:codigo" element={
            <TelaPermissao permissoes={["FinanceiroContaMovimentacaoListarPorIdentificador"]}>
                <MovimentacaoVisualizar
                    onCancelar={() => navigate(-1)}
                />
            </TelaPermissao>
        }/>
    </Routes>
}